(() => {
  if (window.illucoDemoInstalled) return;
  window.illucoDemoInstalled = true;

  let opener = null;

  function openDemo(trigger) {
    const dialog = document.getElementById('IllucoDemoDialog');
    if (!dialog || dialog.open) return;

    opener = trigger || document.activeElement;

    const field = dialog.querySelector('[data-demo-product-field]');
    const product = trigger?.dataset.demoProduct;

    if (field && product) field.value = product;
    // Set the request type when opened from a button or header link.
// Preserve the selection when reopening after a form submission.
if (trigger) {
  const requestField = dialog.querySelector('[data-demo-request-field]');
  const requestType = trigger.dataset.demoRequest || 'Book a demo';

  if (requestField) {
    requestField.value = requestType;
    requestField.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

    dialog.showModal();
    document.documentElement.classList.add('illuco-demo-open');

    const focusTarget =
      dialog.querySelector('[data-demo-result]') ||
      dialog.querySelector('input:not([type="hidden"])') ||
      dialog.querySelector('[data-illuco-demo-close]');

    focusTarget?.focus();
  }

  function initializeDemo() {
    const dialog = document.getElementById('IllucoDemoDialog');
    if (!dialog || dialog.dataset.initialized) return;

    dialog.dataset.initialized = 'true';

    dialog.querySelector('[data-illuco-demo-close]')
      ?.addEventListener('click', () => dialog.close());

    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;

      const bounds = dialog.getBoundingClientRect();
      const outside =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;

      if (outside) dialog.close();
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('illuco-demo-open');
      if (opener?.isConnected) opener.focus();
    });

    // Scope automatic reopening to this form's response anchor.
    if (
      location.hash === '#IllucoDemoForm' &&
      dialog.querySelector('[data-demo-result]')
    ) {
      openDemo();
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const trigger = event.target.closest(
      '[data-illuco-demo-open], a[href="#schedule-demo"]'
    );

    if (!trigger) return;

    event.preventDefault();
    initializeDemo();
    openDemo(trigger);
  });

  document.addEventListener('shopify:section:load', initializeDemo);

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('#IllucoDemoDialog')) {
      document.documentElement.classList.remove('illuco-demo-open');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDemo, {
      once: true
    });
  } else {
    initializeDemo();
  }
})();